<script lang="ts">
    import type { BillPosition } from '../../api/bills';
    import { positionLabel, positionStyles } from './billPositions';

    export let position: BillPosition;
</script>

<span
    class="inline-flex shrink-0 items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium ring-1 ring-inset {positionStyles[position].pill}"
    data-testid="bill-position-pill"
>
    <span class="h-1.5 w-1.5 rounded-full {positionStyles[position].dot}" aria-hidden="true"></span>
    {positionLabel(position)}
</span>
